import React from 'react';
import { portfolioData } from '../data/mock';
import { Github, ExternalLink } from 'lucide-react';
import { Card } from './ui/card';

const OpenSourceSection = () => {
  const { openSource } = portfolioData;

  if (!openSource || openSource.length === 0) return null;

  return (
    <section
      id="open-source"
      className="py-20 px-4 sm:px-6 lg:px-8 bg-[#0f1419]"
      data-testid="open-source-section"
    >
      <div className="max-w-5xl mx-auto">
        <div className="mb-12">
          <h2 className="text-3xl sm:text-4xl font-bold text-white mb-2">
            <span className="text-emerald-400 font-mono text-xl">06.</span> Open Source
          </h2>
          <p className="text-gray-400 mt-3 max-w-2xl">
            Selected contributions to upstream projects I rely on at work.
          </p>
          <div className="h-px bg-gray-700 mt-4"></div>
        </div>

        <div className="grid gap-5 md:grid-cols-2">
          {openSource.map((item) => (
            <Card
              key={item.id}
              className="bg-[#1a1d29] border-gray-800 hover:border-emerald-500/50 transition-all duration-300 p-6 flex flex-col"
              data-testid={`open-source-card-${item.id}`}
            >
              <div className="flex items-start gap-3 mb-3">
                <div className="w-10 h-10 rounded-lg bg-emerald-500/10 flex items-center justify-center flex-shrink-0">
                  <Github size={20} className="text-emerald-400" />
                </div>
                <div className="flex-1 min-w-0">
                  <a
                    href={item.link}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-lg font-bold text-white hover:text-emerald-400 transition-colors break-words inline-flex items-center gap-2"
                    data-testid={`open-source-link-${item.id}`}
                  >
                    {item.project}
                    <ExternalLink size={14} className="text-gray-500" />
                  </a>
                  <p className="text-sm text-emerald-400 font-mono mt-0.5">{item.role}</p>
                </div>
              </div>

              <p className="text-gray-300 text-sm leading-relaxed mb-4">
                {item.description}
              </p>

              {item.highlights && item.highlights.length > 0 && (
                <ul className="space-y-2 mb-4">
                  {item.highlights.map((h, idx) => (
                    <li key={idx} className="flex items-start gap-2 text-gray-300 text-sm">
                      <span className="text-emerald-400 mt-1 flex-shrink-0">▹</span>
                      <span className="leading-relaxed">{h}</span>
                    </li>
                  ))}
                </ul>
              )}

              {item.tags && item.tags.length > 0 && (
                <div className="flex flex-wrap gap-2 mt-auto pt-2">
                  {item.tags.map((tag) => (
                    <span
                      key={tag}
                      className="px-2 py-1 rounded text-xs font-mono bg-emerald-500/10 text-emerald-400 border border-emerald-500/20"
                    >
                      {tag}
                    </span>
                  ))}
                </div>
              )}
            </Card>
          ))}
        </div>
      </div>
    </section>
  );
};

export default OpenSourceSection;
